import { Button } from '@material-ui/core'

const ToggleButton = ({ toggled, onClick, children, fullWidth }) => (
  <Button
    variant={toggled ? 'contained' : 'outlined'}
    color={toggled ? 'primary' : 'default'}
    onClick={onClick}
    fullWidth={fullWidth}
  >
    {children}
  </Button>
)

export default ToggleButton
